import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['MORE STRUCTURE.', 'MORE CLARITY.', 'BETTER VISUAL EXPLANATIONS.', 'CLEARER PROGRESSIONS.', 'FASTER CORRECTIONS.', 'LESS PLANNING.'];
const alreadyHave = ['You already have the framework.', 'You already have the progression.', 'You already have the visual explanation.', 'You already have the correction tools.', 'You already have the assessments.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-stone-200" data-id="element-52" data-mp="1dfryhozw6h5q">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-53" data-mp="18ngv2c5y0d8f">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-blue-950 mb-6" data-id="element-54" data-mp="216e316aotjaz">
          Driving Instructors Don&apos;t Need More Random Information.
        </h2>
        <p className="text-xl text-slate-700 mb-5" data-id="element-55" data-mp="24ww94olg5u5u">They need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-56" data-mp="28wy9mufg4hjj">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-orange-600 tracking-wide" data-id="element-57" data-mp="1v6l2uveaj8vs">
              {need}
            </li>)}
        </ul>
        <div className="bg-stone-50 border border-stone-200 rounded-2xl p-8 text-lg text-slate-800 space-y-2 text-left sm:text-center" data-id="element-58" data-mp="1l7lsn8dvn56o">
          <p className="mb-4" data-id="element-59" data-mp="1q7rpr42x1jw5">
            With Driving Instructor Ready, you don&apos;t begin every lesson from an empty page.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-blue-950 font-semibold flex items-center sm:justify-center gap-2" data-id="element-60" data-mp="1h5ihkkv4e2lx">
              <Check size={18} className="text-green-600 shrink-0" aria-hidden="true" data-id="element-61" data-mp="36lq6q2q5rdgz" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-62" data-mp="3954t43i0f6q9">And with 150 ready-to-teach lessons:</p>
          <p className="text-2xl md:text-3xl font-serif font-extrabold text-blue-950" data-id="element-63" data-mp="393a70lv058kl">
            YOU ALREADY HAVE <span className="text-orange-600" data-id="element-64" data-mp="3565qipjr3m1z">THE LESSON.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}